
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"46","height":"45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.771 33.756v8.89a1.44 1.44 0 001.438 1.437c.448 0 .881-.21 1.157-.586l5.2-7.077-7.795-2.664zM45.396.267a1.438 1.438 0 00-1.499-.104L.772 22.683a1.438 1.438 0 00.2 2.635l11.989 4.099 25.531-21.83-19.757 23.802 20.093 6.868a1.444 1.444 0 001.211-.132c.364-.223.611-.597.675-1.017l5.27-35.458a1.44 1.44 0 00-.588-1.383z"}})])
          )
        }
      }
    